import React from 'react'
import Header from 'semantic-ui-react/dist/commonjs/elements/Header'

const NewCustomerHeader = () => <Header as="h2">New Customer:</Header>

export default NewCustomerHeader
